import { createContext, useContext } from 'react';
import { EnrichedEvent } from '../components/EventsList';

const EnrichedEventsContext = createContext<EnrichedEvent[]>([]);

export const EnrichedEventsProvider = EnrichedEventsContext.Provider;

export const useEnrichedEvents = () => useContext(EnrichedEventsContext);
